import { render, staticRenderFns } from "./MenuSelector.vue?vue&type=template&id=65fa5f54&"
import script from "./MenuSelector.vue?vue&type=script&lang=js&"
export * from "./MenuSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports